export const EMPLOYMENT_STATUS = {
    0: 'Previous Job',
    1: 'Full Time',
    2: 'Part Time',
    3: 'Student',
    4: 'Social Assistance'
}